module.exports = __webpack_public_path__ + "img/other_bank.7a4d97a1.svg";